import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { useTranslation } from 'react-i18next';
import { useGetEosEstimatedEnergyCostQuery } from '@client/api';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { NoDataWidgetContent } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';
import { BiDollar } from 'react-icons/bi';
import { toNumberString } from '@client/toolkit';

export function EstimatedEnergyCostWidget() {
  const { t: tWidget } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();
  const { data, isLoading, isError } = useGetEosEstimatedEnergyCostQuery(
    {
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso,
    },
  );

  const { costTotal = 0, costM2 = 0 } = data ?? {};

  return (
    <DashboardCardWrapper
      to="/reporting/economy-energy-consumption"
      icon={<BiDollar className="text-brand-primary" />}
      title={tWidget('estimatedCosts.title')}
      tooltip=""
      loading={isLoading}
      contentClassName="justify-between"
    >
      {isError ? (
        <NoDataWidgetContent noDataText={tWidget('energy.noData')} />
      ) : (
        <>
          <div className="flex flex-col gap-2 pb-5">
            <div className="flex items-end gap-2 text-white text-4xl">
              <span className="leading-none font-semibold">{toNumberString(costTotal, undefined, { maximumFractionDigits: 0 })}</span>
              <span className="text-white/80 text-sm">kr</span>
            </div>
            <div className="flex items-end gap-2 text-white text-2xl">
              <span className="leading-none font-semibold">{toNumberString(costM2, undefined, { maximumFractionDigits: 0 })}</span>
              <span className="text-white/80 text-sm">kr/m²</span>
            </div>
          </div>
          <span className="text-white/30 text-xs"> {tWidget('estimatedCosts.description')}</span>
        </>
      )}
    </DashboardCardWrapper>
  );
}
